

























































import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from 'vuex-class'
import User, {UserAttributeValidValue} from '@/modules/user/model/User';

/**
 * Tabla para editar los atributos del usuario que se encuentra en edición actualmente
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class UserAttributes extends Vue {
    /**
     * Usuario actualmente en edición
     */
    @State(state => state.user.currentUser)
    public user: User

    public newAttributeDialog = false
    public newAttribute = {
        key: '',
        value: '',
        type: 'string',
    }

    public attributeTypes = [
        { value: 'string', text: 'Cadena de texto', icon: 'mdi-format-text'},
        { value: 'number', text: 'Número', icon: 'mdi-numeric'},
        { value: 'boolean', text: 'Booleano', icon: 'mdi-electric-switch'},
    ]

    public attributeTypeIcon (type: string) {
        return this.attributeTypes.find(t => t.value === type)!.icon
    }

    public get items () {
        return Object.keys(this.user.attributes).map(key => ({key, value: this.user.attributes[key]}))
    }

    /**
     * Cabeceras de la tabla
     */
    public headers = [
        { text: 'Clave del atributo', value: 'key'},
        { text: 'Valor', value: 'value'},
        { text: 'Acciones', value: 'actions', sortable: false},
    ]

    public addAttribute () {
        const { key, value, type } = this.newAttribute
        this.$store.commit('user/SET_USER_ATTRIBUTE', {
            key,
            value: this.parseAttributeValue(value, type),
        })

        this.newAttributeDialog = false
        this.newAttribute = {
            key: '',
            value: '',
            type: 'string',
        }
    }

    public parseAttributeValue (value: string, type: 'string' | 'number' | 'boolean' | any) {
        switch (type) {
            case 'number':
                const number = value.includes('.') ? parseFloat(value) : parseInt(value, 10)
                if (isNaN(number)) {
                    throw new Error('El valor del atributo no es un entero')
                }

                return number
            case 'string':
                return value
            case 'boolean':
                return value
            default:
                throw new Error(`El tipo ${type} no es válido`)
        }
    }
}
